import React, {createRef, useState, useEffect} from 'react';
import clsx from "clsx";

export default function Dropdown(props) {

    const labelRef = createRef();
    const sublabelRef = createRef();
    const dropdownOptionsEditorRef = createRef();

    const data = props.data;
    const updateFormData = props.updateFormData;

    let currentOptions = '';

    data.options.forEach((option, index) => {

        if(index === 0){
            currentOptions = option;
        } else {
            currentOptions = `${currentOptions}\n${option}`;
        }

    });

    const [editable, setEditable] = useState(false);
    const [options, setOptions] = useState(currentOptions);

    const handleOpenOptionsEditor = (e) => {

        e.preventDefault();

        setEditable(true);

    }

    const handleCloseOptionsEditor = (e) => {

        e.preventDefault();

        setEditable(false);

    }

    const handleSaveOptions = (e) => {

        e.preventDefault();

        handleCloseOptionsEditor(e);

        setOptions(dropdownOptionsEditorRef.current.value);

        data.options = dropdownOptionsEditorRef.current.value.split(/\r?\n|\r|\n/g);

        updateFormData(data);

    }

    // TODO: solve a problem with saving
    //
    // const handleClickOutside = (e) => {
    //
    //     if(!document.querySelector('#dropdownOptionsEditor').contains(e.target) &&
    //        !document.querySelector('.sendiio-form-dropdown-box > select').contains(e.target)){
    //
    //         // Temporary solution
    //         handleCloseOptionsEditor(e);
    //
    //         // TODO: Solve problems with saving
    //         // handleSaveOptions(e);
    //
    //     }
    //
    // };
    //
    // useEffect(() => {
    //
    //     document.addEventListener('click', handleClickOutside, true);
    //
    //     return () => {
    //         document.removeEventListener('click', handleClickOutside, true);
    //     };
    //
    // }, []);

    useEffect(() => {

        currentOptions = '';

        data.options.forEach((option, index) => {

            if(index === 0){
                currentOptions = option;
            } else {
                currentOptions = `${currentOptions}\n${option}`;
            }

        });

        dropdownOptionsEditorRef.current.value = currentOptions;

        setOptions(currentOptions);

    }, [props]);

    return <div id={data.id} className={clsx("sendiio-form-dropdown-element", `sendiio-form-label-alignment-${data.labelAlignment}`)}>
        <label ref={labelRef}
               className={clsx("sendiio-form-dropdown-label cursor-text", data.required && 'sendiio-form-element-required')}
               format="text"
               contentEditable={true}
               suppressContentEditableWarning={true}
               onBlur={e => {

                   if(data.label !== e.currentTarget.textContent){

                       data.label = e.currentTarget.textContent;

                       updateFormData(data);

                       labelRef.current.textContent = e.currentTarget.textContent;

                   }

               }}
               dangerouslySetInnerHTML={{__html: data.label}} />
        <div className="sendiio-form-element-wrapper ">
            <div className="sendiio-form-dropdown-box">
                <select id={`sendiio-form-dropdown-box-select-${data.id}`}
                        className="form-dropdown"
                        onChange={e => {e.preventDefault()}}
                        onMouseDown={e => {
                            handleOpenOptionsEditor(e);
                        }}
                        name={`select-${data.id}`}
                        data-component="dropdown"
                        aria-label="Type a question"
                        readOnly>
                    <option key={`option-key-none`} value="">{data.placeholder}</option>
                    {data.options.map((item, index) => (
                        <option key={`option-key-${index}`} value={item}>{item}</option>
                    ))}
                </select>
            </div>
            <div className="sendiio-form-dropdown-actions">
                <div className={clsx('editDropdownTextArea')}>
                    <textarea id="dropdownOptionsEditor"
                              ref={dropdownOptionsEditorRef}
                              defaultValue={options}
                              className="dropdownOptionsEditable"
                              rows="5"
                              placeholder="Option 1&#10;Option 2&#10;Option 3" />
                    <button
                        className="btn btn-barebone underline"
                        onClick={e => {
                            handleSaveOptions(e);
                        }}
                    >Save Changes</button>
                </div>
                {/*<div className={clsx('editDropdownTextArea', !editable && 'hidden' )}>
                    <textarea id="dropdownOptionsEditor"
                        ref={dropdownOptionsEditorRef}
                        defaultValue={options}
                        className="dropdownOptionsEditable"
                        rows="5"
                        placeholder="Option 1&#10;Option 2&#10;Option 3" />
                    <button
                        className="btn btn-barebone underline"
                        onClick={e => {
                            handleSaveOptions(e);
                        }}
                    >Save Changes</button>
                </div>
                <button
                    className={clsx('btn', 'btn-barebone', 'underline', editable && 'hidden' )}
                    onClick={e => {
                        handleOpenOptionsEditor(e);
                    }}
                >Edit Options</button>*/}
            </div>
            <p  ref={sublabelRef}
                className="sendiio-form-dropdown-sublabel cursor-text"
                format="text"
                contentEditable={true}
                suppressContentEditableWarning={true}
                onBlur={e => {

                   if(data.sublabel !== e.currentTarget.textContent){

                       data.sublabel = e.currentTarget.textContent;

                       updateFormData(data);

                       sublabelRef.current.textContent = e.currentTarget.textContent;

                   }

                }}
                dangerouslySetInnerHTML={{__html: data.sublabel}} />
        </div>
    </div>

}